<template>
  <div class="bash-box advantage-box">
    <p class="h1-title">{{ indata.FirstTitle }}</p>
    <p class="h2-title">{{ indata.subTitle }}</p>
    <ul class="advantage-content-box">
      <i
        class="advantage-bg"
        :style="'background:url(' + indata.showImage + ') no-repeat 50% 50%;'"
      ></i>
      <li
        :class="'advantage-' + (index + 1)"
        v-for="(item, index) in indata.children"
        :key="index"
      >
        <p class="h3">{{ item.title1 }}</p>
        <p class="detail">
          {{ item.title2 }}
        </p>
      </li>
    </ul>
  </div>
</template>

        
<script>
export default {
  name: "Templates2",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
